import { FilterCard } from '../landing-page/opo-styles';

interface IProps {
    isPast: boolean,
    caseCount: number,
    loading: boolean,
    onIsPastChange: (isPast: boolean) => void,
    onAdd: () => void,
    onExport: () => void
}

const CaseFilter = ({ isPast, caseCount, loading, onIsPastChange, onAdd, onExport }: IProps) => (
    <FilterCard>
        <div className='search-row'>
            <div className='form-group'>
                <label className='control-label'>Cases</label>
                <div className='search-toggles'>
                    <button type='button' className={!isPast ? 'btn active' : 'btn'} onClick={() => onIsPastChange(false)}>Pending Cases</button>
                    <button type='button' className={isPast ? 'btn active' : 'btn'} onClick={() => onIsPastChange(true)}>Past Cases</button>
                </div>
            </div>

            <div className='search-actions'>
                <button type='button' className='btn btn-primary' onClick={onAdd}>Add Case</button>
                <button type='button' className='btn' disabled={caseCount == 0} onClick={onExport}>Export CSV</button>
            </div>

            <div className='search-stats'>
                <div className='search-stat'>
                    <span className='k'>{isPast ? 'Past Cases' : 'Pending Cases'}</span>
                    <span className='v'>{loading ? '–' : caseCount}</span>
                </div>
            </div>
        </div>
    </FilterCard>
);

export default CaseFilter;
